import "./App.css";

function App() {
  const openInTab = (url: string, name: string) => {
    window.open(url, name, "resizable=0,width=441,height=899");
  };

  return (
    <div className="app">
      <div className="container">
        <div className="headerText">Project Previews</div>
        <div className="subText">Select a project to preview</div>
        <button
          className="button"
          onClick={() =>
            openInTab(
              "https://booking-app-tu3v.onrender.com/",
              "Techstop Mobile"
            )
          }
        >
          Techstop Mobile
        </button>
        <button
          className="invertedButton"
          onClick={() =>
            openInTab("https://meal-cart.onrender.com/", "Meal central")
          }
        >
          Meal Central
        </button>
      </div>
    </div>
  );
}

export default App;
